/**
 * Loads a script from the given URL and returns a promise that resolves to the script element.
 * @param url - The URL of the script to load.
 * @param async - Whether the script should be loaded asynchronously.
 * @returns A promise that resolves to the script element.
 */
export function loadScript(url: string, async = true): Promise<HTMLScriptElement> {
	return new Promise<HTMLScriptElement>((resolve, reject) => {
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = async
		script.src = url

		script.addEventListener('load', () => {
			resolve(script)
		})

		script.addEventListener('error', (errorEvent) => {
			script.remove()
			reject(new Error(errorEvent.message || `script '${url}' failed to load`, { cause: errorEvent }))
		})

		document.body.appendChild(script)
	})
}
